/* Tysk katalog for locale-autopilot-followup.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('de', {
  'ap.skip.title': 'Nachverfolgung überspringen',
  'ap.skip.nextMonth': 'Nächsten Monat erinnern',
  'ap.skip.always': 'Diesen Punkt ignorieren',
  'ap.skip.help': 'Verschiebe den Punkt auf nächsten Monat oder ignoriere genau diesen Punkt. Neue Rechnungen, Kunden und andere neue Funde werden weiterhin angezeigt.',
  'ap.skip.itemFallback': 'Dieser Nachverfolgungspunkt',
  'ap.skip.all': 'Alle überspringen',
  'ap.skip.allInvoices': 'Alle Dokumente in dieser Liste',
  'ap.skip.allCustomers': 'Alle Kunden in dieser Liste',
  'ap.agent.followup.title': 'Nachverfolgungsagent',
  'ap.agent.followup.detail': 'Erfasst Angaben und Abweichungen, die zu keinem Einreichungsagenten gehören.',
  'ap.permission.followup.label': 'Nachverfolgungsagent',
  'ap.permission.followup.desc': 'Erfasst Angaben, Kundendialoge und Abweichungen, die zu keinem Einreichungsagenten gehören.',
  'ap.lineIgnoredToast': 'Dieser Punkt wird ignoriert. Neue Nachverfolgungspunkte werden weiterhin angezeigt.',
  'ap.linesSkippedToast': '{{count}} Punkte wurden übersprungen.',
  'ap.followup.correctionOne': '{{count}} Fehler muss korrigiert werden.',
  'ap.followup.correctionMany': '{{count}} Fehler müssen korrigiert werden.',
  'ap.followup.correctionDetailOne': '{{count}} Punkt muss korrigiert werden',
  'ap.followup.correctionDetailMany': '{{count}} Punkte müssen korrigiert werden',
  'ap.followup.mustCorrect': 'Muss korrigiert werden',
  'ap.followup.correct': 'Korrigieren',
  'ap.followup.correctInSettings': 'In den Einstellungen korrigieren',
});
